var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('van-overlay',{attrs:{"show":_vm.show}},[_c('div',{staticClass:"wrapper"},[_c('van-loading',{attrs:{"type":"spinner","color":"var(--color-primary)"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }